module.exports = __webpack_public_path__ + "static/images/hero.5f164d4665af899f2e729e52404e2438.jpg";